import { Directive, ElementRef, HostListener, NgZone } from '@angular/core';

@Directive({
  selector: 'input[type="number"]:not([noGlobal])',
  standalone: false,
})
export class InputNumberDirective {
  // Digitos, separador decimal y signo negativo. Coherente con lo que ya se filtra
  // en onInput (e, E, coma) y en onKeyDown (e, E, mas).
  private static readonly ALLOWED_CHARS = /^[0-9.\-]+$/;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private ngZone: NgZone  // Inyectar NgZone
  ) {
    this.el = elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const cleanValue = this.el.value.replace(/[eE,]/g, '');

    // 1. Evitar cambios innecesarios
    if (cleanValue === this.el.value) return;

    // 2. Guardar posición del cursor ANTES de cambiar el valor
    const start = this.el.selectionStart;

    this.el.value = cleanValue;

    // 3. Usar NgZone.runOutsideAngular para evitar conflictos con el ciclo de detección
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // 4. Verificar si el elemento aún existe
        if (document.body.contains(this.el)) {
          // 5. Asegurar que la posición sea válida
          const newPosition = Math.min(start ?? 0, cleanValue.length);
          this.el.setSelectionRange(newPosition, newPosition);
        }
      });
    });

    // 6. Disparar evento manualmente
    this.el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (['e','E','+'].includes(event.key)) {
      event.preventDefault();
    }
  }

  // Firefox no descarta los caracteres no numericos en los input[type="number"]: los pinta
  // y deja el valor en "" (badInput), asi que el saneado de onInput no puede limpiarlos.
  // Se rechaza la insercion antes de que ocurra (teclado, pegado y arrastrar y soltar).
  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent) {
    // Sin datos a insertar (borrados, deshacer...) no hay nada que validar.
    if (event.data == null) return;

    if (!InputNumberDirective.ALLOWED_CHARS.test(event.data)) {
      event.preventDefault();
    }
  }
}
